import { Modal, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { FC, useState } from "react";

const { Text } = Typography;

interface ConfirmRegIdHistoryModalProps {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  isRegistrationIdUpdationLoading: boolean;
}

const ConfirmRegIdHistoryModal: FC<ConfirmRegIdHistoryModalProps> = ({
  open,
  onOk,
  onCancel,
  isRegistrationIdUpdationLoading,
}) => {
  return (
    <Modal
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText="Yes, Update"
      okButtonProps={{
        disabled: isRegistrationIdUpdationLoading,
        style: {
          backgroundColor: "rgb(0, 76, 143)",
          borderColor: "rgb(0, 76, 143)",
          color: "#fff",
          boxShadow: "0px 2px 8px 0px #00000040",
        },
      }}
      cancelButtonProps={{
        style: {
          borderColor: "rgb(0, 76, 143)",
          color: "rgb(0, 76, 143)",
        },
        onMouseEnter: (e) => {
          e.currentTarget.style.borderColor = "rgb(0, 76, 143)";
          e.currentTarget.style.color = "rgb(0, 76, 143)";
        },
        onMouseLeave: (e) => {
          e.currentTarget.style.borderColor = "";
          e.currentTarget.style.color = "";
        },
      }}
      confirmLoading={isRegistrationIdUpdationLoading}
      cancelText="Cancel"
      title={null}
      centered
      width={600}
      bodyStyle={{ textAlign: "center" }}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid rgb(0, 76, 143)",
          borderRadius: "50%",
          padding: "6px",
          boxShadow: "0 24px 24px rgba(0, 0, 0, 0.15)",
          backgroundColor: " #ffffff",
          marginBottom: "8px",
        }}
      >
        <CheckOutlined style={{ fontSize: "14px", color: "rgb(0, 76, 143)" }} />
      </div>
      <Title level={3} style={{ marginTop: 16 }}>
        Update Registration ID?
      </Title>
      <Text style={{ display: "block", marginBottom: 24 }}>
        Are you sure. Do you want to update the Registration ID?
      </Text>
    </Modal>
  );
};

export default ConfirmRegIdHistoryModal;
